<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <p class="font-bold text-2xl mb-5" :class="{ 'mb-20': step === 2 }">
      <template v-if="step === 1">
        {{ $t("professionalRating.phone.title") }}
      </template>
      <template v-else>
        {{ $t("professionalRating.phone.enterSmsCode") }}
      </template>
    </p>
    <template v-if="step === 1">
      <p class="font-light text-2xl mb-10">
        {{ $t("professionalRating.phone.onlyWithTenderInfo") }}
        <br />
        {{ $t("professionalRating.phone.enterPhoneNumberPrompt") }}
      </p>
      <div>
        <JoszakiInputOld
          v-model="phone"
          :rules="{
            required: true,
            mobile:
              /^\+36\ (20|21|30|31|50|70)\ [0-9]{3,3}-[0-9]{2,2}-[0-9]{2,2}$/,
          }"
          :placeholder="$t('newTender.placeHolder.mobile')"
          icon-left="phone"
          class="mb-4 block"
          mask="+36 ## ###-##-##"
          type="tel"
          :label="$t('professionalRating.phone.codeInputLabel')"
          @keydown.native.enter="handleSubmit(callPhoneCheck)"
        />
        <div class="mb-1">
          <JoszakiButton
            class="w-full text-2xl"
            @click="handleSubmit(callPhoneCheck)"
          >
            {{ $t("professionalRating.phone.sendCode") }}
          </JoszakiButton>
        </div>
      </div>
    </template>
    <template v-if="step === 2">
      <div>
        <JoszakiInputOld
          v-model="code"
          mask="#####"
          class="mb-4 block"
          :rules="{ required: true, min: 5, max: 5 }"
          icon-left="lock"
          @keydown.native.enter="handleSubmit(callCodeCheck)"
        />
        <div class="mb-4">
          <JoszakiButton
            class="w-full text-2xl"
            :disabled="!isCodeValid"
            @click="handleSubmit(callCodeCheck)"
          >
            {{ $t("professionalRating.phone.sendCode") }}
          </JoszakiButton>
        </div>
      </div>
    </template>
  </ValidationObserver>
</template>

<script>
import { useAuthStore } from "~/components/_refactored/auth";
import { useRating } from "~/components/_refactored/rating/useRating";

export default {
  setup() {
    const rating = useRating();
    return {
      rating,
      authStore: useAuthStore(),
    };
  },
  data: () => ({
    loading: false,
    step: 1,
    tryNumber: 1,
    phone: "+36",
    code: null,
    mobileReg: /^(20|21|30|31|50|70)[0-9]{7,7}$/,
    mobiles: [20, 30, 31, 50, 70],
  }),
  computed: {
    person() {
      return this.rating.state.person;
    },
    mobileAlert() {
      if (this.phoneWithoutSpaces.substr(0, 2).length === 2) {
        if (
          this.mobiles.includes(Number(this.phoneWithoutSpaces.substr(0, 2)))
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    isCodeValid() {
      return this.code?.length === 5;
    },
    phoneWithoutSpaces() {
      return this.phone.replace(/[- ]+?/gm, "").replace("+36", "");
    },
  },
  methods: {
    async callPhoneCheck() {
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        const SENDSMSVERIFICATION = await import(
          "./sendSmsVerification.graphql"
        );
        const res = await this.$mutate(SENDSMSVERIFICATION, {
          phone: this.phoneWithoutSpaces,
          personId: this.personBySeoName.id,
        });
        if (res) {
          this.step = 2;
        } else {
          this.$buefy.toast.open({
            duration: 5000,
            message: this.$t("professionalRating.phone.notFound"),
            position: "is-top",
            type: "is-danger",
          });
        }
        this.loading = false;
      } catch (err) {
        console.error(err);
        this.loading = false;
        this.$buefy.toast.open({
          duration: 5000,
          message: typeof err === "string" ? err : this.$t("error.unknown"),
          position: "is-top",
          type: "is-danger",
        });
        this.$sentry.captureException(err, {
          tags: {
            page: "professional-rating",
            action: "callPhoneCheck",
          },
        });
      }
    },
    async callCodeCheck() {
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        const CHECKSMSVERIFICATION = await import(
          "./checkSmsVerification.graphql"
        );
        const res = await this.$mutate(CHECKSMSVERIFICATION, {
          code: parseInt(this.code),
        });

        this.loading = false;
        if (res) {
          // TOKEN SAVE
          await this.authStore.loginWithToken(res);
          this.rating.nextStep();
        } else {
          this.$buefy.toast.open({
            duration: 5000,
            message: this.$t("professionalRating.phone.wrongCode"),
            position: "is-top",
            type: "is-danger",
          });
        }
      } catch (err) {
        console.error(err);
        this.loading = false;
        this.$buefy.toast.open({
          duration: 5000,
          message: typeof err === "string" ? err : this.$t("error.unknown"),
          position: "is-top",
          type: "is-danger",
        });
        this.$sentry.captureException(err, {
          tags: {
            page: "professional-rating",
            action: "callCodeCheck",
          },
        });
      }
    },
  },
};
</script>
